import { render, staticRenderFns } from "./MainTemperatureComponent.vue?vue&type=template&id=82dea1a0&scoped=true&"
import script from "./MainTemperatureComponent.vue?vue&type=script&lang=js&"
export * from "./MainTemperatureComponent.vue?vue&type=script&lang=js&"
import style0 from "./MainTemperatureComponent.vue?vue&type=style&index=0&id=82dea1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dea1a0",
  null
  
)

export default component.exports